export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  router.onError((error) => {
    console.error("router Error", error);

    // window.setTimeout(() => {
    //   window.location.reload();
    // }, 2000);
  });
});
